import {
  Input,
  InputChangeEvent
} from '@progress/kendo-react-inputs'
import { StackLayout } from '@progress/kendo-react-layout'
import { FC } from 'react'

export interface FromToInputProps {
  limitLeftValue?: string
  limitRightValue?: string
  onLimitLeftChange?: (value: string) => void
  onLimitRightChange?: (value: string) => void
}
export const FromToInput: FC<FromToInputProps> = ({
  limitLeftValue,
  limitRightValue,
  onLimitLeftChange,
  onLimitRightChange
}) => {
  const handleLeftChange = (event: InputChangeEvent) => {
    onLimitLeftChange?.(event.value)
  }

  const handleRightChange = (event: InputChangeEvent) => {
    onLimitRightChange?.(event.value)
  }
  return (
    <StackLayout orientation='horizontal'>
      <Input
        onChange={handleLeftChange}
        value={limitLeftValue}
      />
      {'　～　'}
      <Input
        onChange={handleRightChange}
        value={limitRightValue}
      />
    </StackLayout>
  )
}
